module.exports = __webpack_public_path__ + "static/media/tracking-blue.33d65181.svg";